module.exports = __webpack_public_path__ + "img/tnc.dbe68ce0.svg";